import { LabelModel, LabelModelGenerics, LabelModelOptions } from '@projectstorm/react-diagrams-core';
import { DeserializeEvent } from '@projectstorm/react-canvas-core';

export interface RemoveLinkLabelModelOptions extends LabelModelOptions {
	label?: string;
}

export interface RemoveLinkLabelModelGenerics extends LabelModelGenerics {
	OPTIONS: RemoveLinkLabelModelOptions;
}

export class RemoveLinkLabelModel extends LabelModel<RemoveLinkLabelModelGenerics> {
  constructor(options: RemoveLinkLabelModelOptions = {}) {
    super({
      ...options,
      offsetY: options.offsetY == null ? -23 : options.offsetY,
      type: 'customLabel',
    });
  }

  setLabel(label: string) {
    this.options.label = label;
  }

  deserialize(event: DeserializeEvent<this>) {
    super.deserialize(event);
    this.options.label = event.data.label;
  }

  removeLink() {
    this.parent.remove();
    this.fireEvent({ link: this.parent }, 'linkDeleted');
  }

  serialize() {
    return {
      ...super.serialize(),
      label: this.options.label,
    };
  }
}
